import React from 'react';
import { Layout, Menu, Dropdown, Button, Typography } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import {useAuth} from "../contexts/AuthContext";
import {useNavigate} from "react-router-dom";
import {useEpisode} from "../contexts/EpisodeContext";
const { Header, Sider, Content } = Layout;

const MasterLayout = ({ topNavLeftContent, sider, children }) => {
    const { auth, logout } = useAuth();
    const { episode } = useEpisode();
    const navigate = useNavigate();

    const userMenu = (
        <Menu style={{ backgroundColor: "#000" }}>
            {auth.userData?.role === "omni" &&
                <Menu.Item key="function">
                    <Button type="text" onClick={() => navigate("/omni")}>
                        Function Select
                    </Button>
                </Menu.Item>
            }
            <Menu.Item key="logout">
                <Button type="text" onClick={logout}>
                    Logout
                </Button>
            </Menu.Item>
        </Menu>
    );

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header style={{ padding: 14, background: '#000', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                { topNavLeftContent }
                {episode?.installment &&
                    <Typography.Title level={3} style={{ color: "#fff" }}>Episode: {episode?.installment} - Entries: {episode?.entriesCount}</Typography.Title>
                }
                <Dropdown overlay={userMenu} trigger={['click']}>
                    <a onClick={e => e.preventDefault()} href="/" style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontSize: "14px", fontStyle: "bold", color: "#fff" }}>{auth.userData?.email}</span>
                        <DownOutlined style={{ marginLeft: 8 }} />
                    </a>
                </Dropdown>
            </Header>
            <Layout style={{ background: '#E2010C' }}>
                {sider &&
                    <Sider trigger={null} collapsible collapsed={false} style={{ background: '#000' }}>
                        {sider}
                    </Sider>
                }
                <Content style={{ margin: '24px 16px', padding: 24, background: '#000', minHeight: 280 }}>
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
};

export default MasterLayout;